// extracted by mini-css-extract-plugin
export var copyIcon = "_r4-2";
export var discountCard = "_r4-0";
export var discountCode = "_r4-3";
export var discountContent = "_r4-1";
export var loadingCard = "_r4-4";